import bidManager from './bidManager';
import logger from './logger';
const BIDDER_TIMEOUT = 1500;
const initGpt = () => {
    if (window.googletag) {
        return window.googletag;
    }
    window.googletag = { cmd: [] };
    return window.googletag;
};
const GptCreate = ({ bidderTimeout = BIDDER_TIMEOUT, bidders = [], adTargeting = [], }) => {
    let slots = [];
    const hasMarketingConsent = /(^|;)\s*CookieConsent=[^;]*marketing:true/.test(document.cookie);
    const consentBidders = hasMarketingConsent ? bidders : [];
    const targetingArray = hasMarketingConsent ? adTargeting : [];
    targetingArray.push(['advelvet', [String(Math.floor(Math.random() * 20) + 1)]]);
    const adTag = initGpt();
    bidManager.init(consentBidders);
    const addPlacement = (opt) => {
        logger.log('addPlacement, network:', opt.network, 'targeting:', targetingArray);
        if (!opt.network) {
            throw new Error('"network" can not be empty string');
        }
        const slotSizes = opt.sizes || [];
        const targeting = targetingArray.concat(opt.targetingArray || []);
        let adRequestSent = false;
        const sendAdRequest = () => {
            const slot = getSlot();
            if (adRequestSent || !slot) {
                return undefined;
            }
            adTag.cmd.push(() => {
                window.googletag?.pubads().refresh(slots);
                adRequestSent = true;
            });
        };
        destroySlot();
        adTag.cmd.push(() => {
            if (!window.googletag) {
                return;
            }
            const getOutOfPageId = () => targeting.some(x => x[0] === 'interstitial') && window.googletag
                ? window.googletag.enums.OutOfPageFormat.INTERSTITIAL
                : opt.divId;
            const slot = slotSizes.flat().includes('Out-of-page')
                ? window.googletag.defineOutOfPageSlot(opt.network, getOutOfPageId())
                : window.googletag.defineSlot(opt.network, slotSizes, opt.divId);
            for (let i = 0; i < targeting.length; i++) {
                const target = targeting[i];
                if (target.length === 2) {
                    slot.setTargeting(target[0], target[1]);
                }
            }
            slot.setCollapseEmptyDiv(true).addService(window.googletag.pubads());
            slots = [slot];
            window.googletag.display(slot);
            refreshPlacement();
        });
        if (consentBidders?.length && /(^|;\s*)__gads=/.test(document.cookie)) {
            const numberSizes = slotSizes.filter(sizes => Array.isArray(sizes) &&
                !sizes.some((size) => typeof size === 'string'));
            numberSizes.length &&
                bidManager.requestBids(opt.divId, opt.network, numberSizes, consentBidders, sendAdRequest);
            setTimeout(sendAdRequest, bidderTimeout);
        }
        else {
            sendAdRequest();
        }
    };
    const refreshPlacement = () => {
        const slot = getSlot();
        if (!slot) {
            return;
        }
        const id = getSlotElementId();
        if (!id) {
            return;
        }
        adTag.cmd.push(() => {
            window.googletag?.display(id);
            window.googletag?.pubads().refresh(slots);
        });
    };
    const addEventListener = (eventType, listener) => {
        adTag.cmd.push(() => {
            window.googletag?.pubads().addEventListener(eventType, listener);
        });
    };
    const getSlot = () => slots[0];
    const destroySlot = () => {
        adTag.cmd.push(() => {
            window.googletag?.destroySlots(slots);
        });
        slots = [];
    };
    const getSlotElementId = () => getSlot()?.getSlotElementId();
    return {
        addPlacement,
        addEventListener,
        getSlot,
        destroySlot,
        refreshPlacement,
        getSlotElementId,
    };
};
export default GptCreate;
//# sourceMappingURL=gpt.js.map